// extracted by mini-css-extract-plugin
module.exports = {"refuse":"refuseEntityModal_refuse__2XFQH","btns":"refuseEntityModal_btns__2anPN"};